<template>
  <ul v-if="retails.length > 4" class="list">
    <li v-for="(item, idx) in visible" :key="idx">
      {{ `x${item.quantity} ${item.price_name}` }}
    </li>

    <li class="link" @click="onShowMore">
      {{ $t("button.show-more") }}
    </li>
  </ul>

  <ul v-else-if="retails.length" class="list">
    <li v-for="(item, idx) in retails" :key="idx">
      {{ `x${item.quantity} ${item.price_name}` }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useParsedRow } from "../../composables/useParsedRow";
import { useOrdersDialogsInject } from "../../composables/useOrdersDialogs";

const props = defineProps<{ row: Record<string, unknown> }>();

const dialogs = useOrdersDialogsInject();
const parsed = useParsedRow(props.row);

const retails = computed(() => parsed.retails);
const visible = computed(() => retails.value.slice(0, 4));

/**
 * Open the shared retails dialog with this row's full retail list.
 *
 * @returns {boolean} Sentinel.
 */
function onShowMore(): boolean {
  dialogs.openRetails(retails.value);

  return true;
}
</script>

<style scoped lang="scss">
@use "@/styles/variables.scss" as *;

.list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  color: $color-dark-cyan;
}
</style>
